import _ from 'underscore';

export default {
    /**
     * Converts a type info or function returning a type info into the property definition.
     * @param {*} typeRef
     * @returns {Object}
     */
    toPropertyDef: function toPropertyDef(typeRef) {
        if (_.isFunction(typeRef)) {
            return {
                'get': typeRef
            };
        }

        return {
            'value': typeRef
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-metadata-js/_PropertyDefinitionUtil.js
// module id = 319
// module chunks = 0